import { CSSProperties, useEffect, useRef, memo, FunctionComponent } from 'react';
import { IVideo } from '../../r3f-components/component-data-structure';
import * as CSS from './VideoModal.scss';
import { hlsVideoCache } from '@/components/r3f-components/hooks';
import { IUserActions, useUserStore } from '@/zustand';

interface IParentProps {
	videoData: IVideo;
}

const VideoModal: FunctionComponent<IParentProps> = ({ videoData }) => {
	const userDispatch = useUserStore((state) => state.dispatch);
	const containerRef = useRef<HTMLDivElement>(null);
	const {
		id,
		scale: [sx, sy],
	} = videoData;

	const video = hlsVideoCache[id][1];
	const ratio = sy / sx;
	const vw = 100;
	const vh = 100;

	const style: CSSProperties = {
		width: `${vw}vw`,
		height: `${vh * ratio}vw`,
		maxHeight: `${vh}vh`,
		maxWidth: `${(vw * 1) / ratio}vh`,
	};

	useEffect(() => {
		if (!video) return;
		Object.assign(video.style, style);
		const container = containerRef.current;

		if (!container) return;
		container.append(video)
		if (video.paused) video.play();
	}, [])


	const onClose = () => {
		const videoIsPlaying = !video?.paused && !video?.ended;
		const resumeVideo = () => {
			if (!videoIsPlaying) {return};
			video?.play();
			video?.removeEventListener("pause", resumeVideo);
		};

		video?.addEventListener("pause", resumeVideo);
			
		userDispatch({
			type: IUserActions.SET_ENLARGED_VIDEO,
			payload: {
				videoRef: null,
				id: null,
			},
		});
		video?.remove();
	}

	return (
		<>
			<div ref={containerRef} className={CSS.Container} onPointerDown={onClose}></div>
			<div className={CSS.Background} />
		</>
	);
};
export default memo(VideoModal);
